const {
  withDuration,
  isProductPage,
  handleSearchButtonClick,
  renderProduct,
  withSuccessRateLogs,
} = require('../public');

async function masterPageOnReady(_$w, logger, useOnClickOnSiblings = false) {
  logger.log('Velo-NPM: Version 1.2');
  await withDuration('onReady', () => onReady(_$w, logger, useOnClickOnSiblings), logger);
  logger.debugLink();
}

async function onReady(_$w, logger, useOnClickOnSiblings) {
  const _isProductPage = await isProductPage();
  const monitoredRenderProduct = (...args) =>
    withSuccessRateLogs('renderProduct', () => renderProduct(...args));

  if (_isProductPage) {
    await withDuration(
      'renderProduct using NPM - Version 1.2',
      () => monitoredRenderProduct(_$w, logger, useOnClickOnSiblings),
      logger
    );
  }

  // Set Search Button onClick Event
  handleSearchButtonClick(_$w);

  return Promise.resolve();
}

module.exports = {
  masterPageOnReady,
};
